import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  color: var(--black-2);

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const TransferenceItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--black-2);

  padding: 8px 8px 8px 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: var(--white-darker);

  span {
    font-size: 14px;
  }

  .user {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      height: 32px;
      width: 32px;
      border-radius: 50%;
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }

  button {
    padding: 8px 16px;
    border-radius: 8px;
    background: var(--primary);
    color: var(--white);

    cursor: pointer;
  }
`;
